// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"44473d78fc6c7866a1e2","691":"9f67aa4733b196378904"}[chunkId] + ".js";
};